import React, { createContext, useContext, ReactNode } from "react";
import { PageMetadata } from "../model/metadata";

const PageMetadataContext = createContext<PageMetadata | undefined>(undefined);

interface PageMetadataProviderProps {
  metadata: PageMetadata;
  children: ReactNode;
}

export const PageMetadataProvider = ({
  metadata,
  children
}: PageMetadataProviderProps) => (
  <PageMetadataContext.Provider value={metadata}>
    {children}
  </PageMetadataContext.Provider>
);

export const usePageMetadata = () => {
  const location = useContext(PageMetadataContext);
  if (!location) {
    throw new Error(
      "PageMetadataProvider must be used to rely on usePageMetadata."
    );
  }
  return location;
};
